import { createFileRoute } from '@tanstack/react-router';
import { PersonAttributesRoute } from './-route-wrappers';

/** The person profile's Attributes tab at its own URL (FPS-4208). */
function PersonAttributesIndexRoute() {
  return <PersonAttributesRoute />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/people/$personId/attributes/')({
  component: PersonAttributesIndexRoute,
});
